import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmDialogModule, GrowlModule } from 'primeng/primeng';
import { HelperModule } from '../../../../common/helper/helper.module';
import { UploadEvsService } from '../../../../common/services/UploadEvs.service';
import { CardModule } from '../../../../layout/card';
import { PaginationModule } from '../../../../layout/pagination';
import { ToastrModule } from 'ngx-toastr';
import { ContactService } from '../../../../common/services/Contact.service';
import { Select2Module } from 'ng2-select2';
import { SettingsComponent } from './settings.component';
import { UserComponent } from './user/user.component';
import { ServiceComponent } from './service/service.component';
import { PriorityComponent } from './priority/priority.component';
import { TypeComponent } from './type/type.component';
import { TicketComponent } from './ticket/ticket.component';
import { IvrgatewayComponent } from './gateway/ivrgateway.component';
import { QueueAgentComponent } from './queue/queue_agent.component';
import { QueueComponent } from './queue/queue.component';
import { ChatConfigComponent } from './chat/chat_config.component';
import { UserFieldComponent } from './user_field/user_field.component';
import { FieldComponent } from './ticket/field/field.component';
import { EmailComponent } from './email/mail.component';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { IvrComponent } from './ivr/ivr.component';
import { TimeComponent } from './time/time.component';
import { FullCalendarModule } from 'ng-fullcalendar';
import { ColorPickerModule } from 'ngx-color-picker';
import { TemplateComponent } from './template/template.component';
import { PageComponent } from './pages/page.component';
import { AccountComponent } from './account/account.component';
import { BlacklistComponent } from './blacklist/blacklist.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { CqFormComponent } from './cq_form/cq_form.component';
import { CqCategoryComponent } from './cq_category/cq_category.component';
import { CqQasComponent } from './cq_qas/cq_qas.component';
import { CqKeywordComponent } from './cq_keyword/cq_keyword.component';
import { CqFieldComponent } from './cq_field/cq_field.component';
import { CqCriteriaGroupComponent } from './cq_criteriagroup/cq_criteriagroup.component';
import { CqCriteriaComponent } from './cq_criteria/cq_criteria.component';
import { CqScriptComponent } from './cq_script/cq_script.component';
import { CqQuestionComponent } from './cq_question/cq_question.component';
import { TooltipModule } from 'ngx-bootstrap';
import { ConversationModule } from './conversation/conversation.module';
import { ContactModule } from './contact/contact.module';
import { TicketsModule } from './tickets/tickets.module';
import { SwitchboardModule } from './switchboard/switchboard.module';
import { OtherModule } from './other/other.module';
import { ComponentsModule } from '../../../../components/component.module';
import { ExpertModule } from './expert/expert.module';
import { SiptrunkComponent } from './account/siptrunk/siptrunk.component';
import { TenantUserComponent } from './account/user/user.component';
import { AdminUserService } from '../../../../common/services/admins/user.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ConfirmDialogModule,
    GrowlModule,
    TooltipModule,
    BrowserModule,
    HelperModule,
    CardModule,
    PaginationModule,
    ToastrModule.forRoot(),
    Select2Module,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    FullCalendarModule,
    ColorPickerModule,
    BsDatepickerModule.forRoot(),
    TooltipModule,
    ConversationModule,
    ContactModule,
    TicketsModule,
    SwitchboardModule,
    OtherModule,
    ComponentsModule,
    ExpertModule,
  ],

  declarations: [
    SettingsComponent,
    UserComponent,
    ServiceComponent,
    PriorityComponent,
    TypeComponent,
    TicketComponent,
    IvrgatewayComponent,
    QueueComponent,
    QueueAgentComponent,
    ChatConfigComponent,
    UserFieldComponent,
    FieldComponent,
    EmailComponent,
    IvrComponent,
    TimeComponent,
    TemplateComponent,
    PageComponent,
    AccountComponent,
    PageComponent,
    BlacklistComponent,
    CqFormComponent,
    CqQasComponent,
    CqCategoryComponent,
    CqKeywordComponent,
    CqFieldComponent,
    CqCriteriaGroupComponent,
    CqCriteriaComponent,
    CqScriptComponent,
    CqQuestionComponent,
    SiptrunkComponent,
    TenantUserComponent,
  ],
  exports: [SettingsComponent, TicketComponent],
  entryComponents: [QueueAgentComponent],
  providers: [UploadEvsService, ContactService, AdminUserService],
})
export class SettingsModule {}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/settings.module.ts